import { makeStyles } from '@material-ui/core';
var fileInputStyles = makeStyles(function (theme) { return ({
    attachmentIcon: {
        cursor: 'pointer',
    },
    hiddenFileInput: {
        visibility: 'hidden',
    },
}); });
export default fileInputStyles;
//# sourceMappingURL=styles.js.map